import React from 'react'
import _ from 'lodash'
import * as styles from './styles'

const TocLinkList = props => (
  <styles.TocList>
    {_.map(props.links, (link) => {
      return (
        <styles.TocListItem depth={link.depth} key={link.slug}>
          <styles.TocLink depth={link.depth} href={`#${link.slug}`}>{link.text}</styles.TocLink>
        </styles.TocListItem>
      )
    })}
  </styles.TocList>
)

export default ({ content }) => {
  const { markdown } = content

  return (
    <styles.Container>
      <TocLinkList links={markdown.base.headings} />
    </styles.Container>
  )
}
